/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface SmsSettings
 */
export interface SmsSettings {
  /**
   * field name to get phone number from
   * @type {string}
   * @memberof SmsSettings
   */
  phoneField?: SmsSettingsPhoneFieldEnum;
  /**
   * template string for the sms body
   * @type {string}
   * @memberof SmsSettings
   */
  text: string;
}

/**
 * @export
 */
export const SmsSettingsPhoneFieldEnum = {
  PrimaryPhone: 'primary_phone',
  SecondaryPhone: 'secondary_phone',
} as const;
export type SmsSettingsPhoneFieldEnum =
  (typeof SmsSettingsPhoneFieldEnum)[keyof typeof SmsSettingsPhoneFieldEnum];

/**
 * Check if a given object implements the SmsSettings interface.
 */
export function instanceOfSmsSettings(value: object): value is SmsSettings {
  if (!('text' in value) || value['text'] === undefined) return false;
  return true;
}

export function SmsSettingsFromJSON(json: any): SmsSettings {
  return SmsSettingsFromJSONTyped(json, false);
}

export function SmsSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SmsSettings {
  if (json == null) {
    return json;
  }
  return {
    phoneField: json['phone_field'] == null ? undefined : json['phone_field'],
    text: json['text'],
  };
}

export function SmsSettingsToJSON(value?: SmsSettings | null): any {
  if (value == null) {
    return value;
  }
  return {
    phone_field: value['phoneField'],
    text: value['text'],
  };
}
